import { Selectable } from "./abstractions/Selectable";

export class Mode extends Selectable {
    code: string;
    name: string;

    constructor(code: string, name: string, isSelected: boolean) {
        super(name, code);
        this.code = code;
        this.name = name;
        this.selected = isSelected;
    }
}
